// ── Importaciones tal cual ──────────────────────────────
import React, { useState, useEffect } from 'react';
import { MachinesFetchAPI } from '../../api/Machines';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap';
import nada from '../img/icons/nada.png';
import vending_machine from '../img/icons/vending.png';
import ModalviewMachine from './ModalviewMachine';
import ModalOperator from './ModalOperator';
import './vending.css';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .vt-
───────────────────────────────────────────────────────── */
const VT_CSS = `
@keyframes vt-up { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }

/* ── WRAP ── */
.vt-wrap {
  padding: 1.1rem 1.25rem 1.5rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── TOOLBAR ── */
.vt-toolbar {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 1.1rem;
  padding-bottom: .75rem;
  border-bottom: 1.5px solid rgba(0,0,0,.07);
}
.vt-title {
  display: flex; align-items: center; gap: .5rem;
  font-size: .85rem; font-weight: 800; color: #1B3A6B;
  letter-spacing: .01em;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.vt-count {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 22px; height: 22px; padding: 0 .45rem;
  background: #1B3A6B; color: #fff;
  border-radius: 999px; font-size: .68rem; font-weight: 800;
}

/* ── GRID ── */
.vt-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1rem;
}

/* ── MACHINE CARD ── */
.vt-card {
  background: #fff;
  border: 1.5px solid rgba(0,0,0,.08);
  border-radius: 16px;
  overflow: hidden;
  display: flex; flex-direction: column;
  box-shadow: 0 2px 8px rgba(0,0,0,.05);
  transition: box-shadow .18s, border-color .18s, transform .18s;
  animation: vt-up .28s ease both;
}
.vt-card:hover {
  border-color: rgba(27,58,107,.25);
  box-shadow: 0 6px 24px rgba(27,58,107,.13);
  transform: translateY(-3px);
}

/* image area */
.vt-card-top {
  display: flex; align-items: center; gap: .85rem;
  padding: 1rem 1.15rem .85rem;
  background: linear-gradient(135deg, rgba(27,58,107,.06) 0%, rgba(37,99,235,.04) 100%);
  border-bottom: 1px solid rgba(0,0,0,.06);
}
.vt-machine-img {
  width: 56px; height: 56px; object-fit: contain; flex-shrink: 0;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,.15));
}
.vt-card-body { flex: 1; min-width: 0; }
.vt-machine-name {
  font-size: .88rem; font-weight: 800; color: #111827;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  font-family: var(--font-sans,-apple-system,sans-serif);
  margin-bottom: .3rem;
}
.vt-machine-type {
  display: inline-flex; align-items: center;
  padding: .18rem .6rem; border-radius: 7px;
  background: rgba(27,58,107,.09); color: #1B3A6B;
  font-size: .68rem; font-weight: 700; letter-spacing: .03em;
  font-family: var(--font-sans,-apple-system,sans-serif);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  max-width: 100%;
}

/* footer with action buttons */
.vt-card-footer {
  display: flex; gap: .5rem; flex-wrap: wrap;
  padding: .75rem 1.15rem .9rem;
  background: #FAFAFA;
}

/* override modal trigger buttons inside card footer */
.vt-card-footer .btn,
.vt-card-footer button:not(.modal button) {
  flex: 1; border-radius: 9px !important; font-size: .76rem !important;
  font-weight: 600 !important; padding: .42rem .6rem !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  transition: all .13s !important;
}
.vt-card-footer .btn-outline-primary { border-color: rgba(27,58,107,.3) !important; color: #1B3A6B !important; }
.vt-card-footer .btn-outline-primary:hover { background: #1B3A6B !important; color: #fff !important; border-color: #1B3A6B !important; }

/* ── EMPTY STATE ── */
.vt-empty {
  grid-column: 1 / -1;
  display: flex; flex-direction: column; align-items: center;
  gap: .75rem; text-align: center;
  padding: 3rem 1.5rem;
  background: #fff;
  border: 1.5px dashed rgba(27,58,107,.18);
  border-radius: 16px;
}
.vt-empty-img {
  width: 90px; height: 90px; object-fit: contain; opacity: .55;
}
.vt-empty-title {
  font-size: .98rem; font-weight: 800; color: #374151; margin: 0;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.vt-empty-sub {
  font-size: .8rem; color: #9CA3AF; max-width: 340px; margin: 0; line-height: 1.6;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── RESPONSIVE ── */
@media(max-width: 640px) {
  .vt-grid { grid-template-columns: 1fr 1fr; }
  .vt-wrap { padding: .85rem .9rem 1.2rem; }
}
@media(max-width: 420px) {
  .vt-grid { grid-template-columns: 1fr; }
}
`;

if (typeof window !== 'undefined' && !document.getElementById('vt-styles')) {
  const el = document.createElement('style');
  el.id = 'vt-styles'; el.textContent = VT_CSS;
  document.head.appendChild(el);
}

/* ── ICON ── */
const IcoVending = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="2" width="18" height="20" rx="2"/>
    <path d="M8 2v20M3 8h5M3 12h5M3 16h5"/>
    <rect x="11" y="6" width="6" height="4" rx="1"/>
    <rect x="11" y="13" width="6" height="4" rx="1"/>
  </svg>
);

/* ════════════════════════════════════════════════════════
   COMPONENT 
════════════════════════════════════════════════════════ */
const VendingTable = ({ branchoffice_id, eventHandler, token, user }) => {

  /* ════════════════════════════════════
   
  ════════════════════════════════════ */
  const [machines, setMachines] = useState([]);

  useEffect(() => { getMachinesByBranchOffice(); }, [eventHandler]);

  const getMachinesByBranchOffice = async () => {
    try {
      const response = await MachinesFetchAPI.getMachinesByBranchOffice(branchoffice_id, token);
      let data = response.data.data;
      const filtervendingData = data.filter(machine => machine.machine_id === 7);
      setMachines(filtervendingData);
    } catch (err) {
      setMachines([]);
    }
  };

  const viewMachines = () => {
    const list = machines.length > 0
      ? machines.map((machine, index) => (
          <Col sm="6" md="6" lg="4" xl="4" key={index}>
            <ListGroup as="ol" className="m-1">
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start rounded-4"
              >
                <img className="imgitemsList m-1" src={vending_machine} alt="" />
                <div className="ms-2 me-auto d-inline-block text-truncate">
                  <div className="fw-bold">{machine.machine_name}</div>
                  <div className="d-flex justify-constent-center align-items-center" />
                  <div className="">Tipo: <b>{machine.description}</b></div>
                  <div className="m-1">
                    <ModalviewMachine machine={machine} />
                    <ModalOperator machine={machine} token={token} branchoffice_id={branchoffice_id} />
                  </div>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Col>
        ))
      : (
          <div className="position-relative p-5 text-center text-muted bg-body border border-dashed rounded-5">
            <img src={nada} alt="Vacio" />
            <h2 className="text-body-emphasis fw-bold fs-1">Vacío</h2>
            <p className="col-lg-6 mx-auto mb-4 fs-4">
              No se encuentran máquinas vending disponibles en este momento. Le sugerimos seleccionar o verificar una sucursal con disponibilidad.
            </p>
          </div>
        );
    return list;
  };
  /* ════════════════════════════════════
 
  ════════════════════════════════════ */

  /* ── renderCards — nuevo shell visual (misma data que getMachinesByBranchOffice) ── */
  const renderCards = () => {
    if (machines.length === 0) {
      return (
        <div className="vt-empty">
          <img className="vt-empty-img" src={nada} alt="Sin máquinas" />
          <p className="vt-empty-title">Sin máquinas disponibles</p>
          <p className="vt-empty-sub">
            No se encuentran máquinas vending en esta sucursal. Selecciona o verifica una sucursal con disponibilidad.
          </p>
        </div>
      );
    }

    return machines.map((machine, index) => (
      <div
        className="vt-card"
        key={machine.machine_id || index}
        style={{ animationDelay: `${index * 0.05}s` }}
      >
        {/* imagen + info */}
        <div className="vt-card-top">
          <img className="vt-machine-img" src={vending_machine} alt={machine.machine_name} />
          <div className="vt-card-body">
            <div className="vt-machine-name" title={machine.machine_name}>
              {machine.machine_name}
            </div>
            <span className="vt-machine-type">{machine.description}</span>
          </div>
        </div>

        {/* acciones — componentes originales intactos */}
        <div className="vt-card-footer">
          <ModalviewMachine machine={machine} />
          <ModalOperator machine={machine} token={token} branchoffice_id={branchoffice_id} />
        </div>
      </div>
    ));
  };

  /* ══════════════════════════════════
     RENDER
  ══════════════════════════════════ */
  return (
    <>
      {/* ── NUEVO SHELL ── */}
      <div className="vt-wrap">

        {/* toolbar */}
        <div className="vt-toolbar">
          <span className="vt-title">
            <IcoVending /> Vendings
            <span className="vt-count">{machines.length}</span>
          </span>
        </div>

        {/* grid de cards */}
        <div className="vt-grid">
          {renderCards()}
        </div>

      </div>

      {/* ── display:none — preserva viewMachines + imports Bootstrap ── */}
      <div style={{ display: 'none' }}>
        <div className="border rounded-3 p-sm-1 p-lg-4">
          <div className="row mx-1 mt-3">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 p-1 order-0 order-lg-0 order-md-0">
              <div className="d-flex justify-content-lg-between justify-content-md-start justify-content-center">
                <h4 className="fs-5 fw-bold text-left text-primary">
                  Vendings
                  <span className="badge rounded-pill bg-primary-subtle text-primary border-primary shadow-sm rounded-pill mx-1">
                    {machines.length}
                  </span>
                </h4>
              </div>
            </div>
          </div>
          <div className="mt-3">
            <Container>
              <Row>{viewMachines()}</Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendingTable;